import React from 'react';
import Icon from '@atlaskit/icon';
import PullRequestIcon from '@atlaskit/icon/core/pull-request';
import { token } from '@atlaskit/tokens';
import {
	type DevInfoType,
	DevInfoTypes,
} from '@atlassian/jira-development-board-common/src/types.tsx';

type IconProps = {
	label: string;
};

const PullrequestDeclinedIcon = ({ label }: IconProps) => (
	// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
	<Icon
		label={label}
		glyph={() => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="24" height="24" fill={token('color.icon.inverse')} fillOpacity="0.01" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.75 5.25C6.19772 5.25 5.75 5.69772 5.75 6.25C5.75 6.80228 6.19772 7.25 6.75 7.25C7.30228 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 7.30228 5.25 6.75 5.25ZM3.75 6.25C3.75 4.59315 5.09315 3.25 6.75 3.25C8.40685 3.25 9.75 4.59315 9.75 6.25C9.75 7.55622 8.91519 8.66746 7.75 9.07929V20.25C7.75 20.8023 7.30228 21.25 6.75 21.25C6.19772 21.25 5.75 20.8023 5.75 20.25V9.07929C4.58481 8.66746 3.75 7.55622 3.75 6.25Z"
					fill={token('color.icon.danger')}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25V15.4207C18.9152 15.8325 19.75 16.9438 19.75 18.25C19.75 19.9069 18.4069 21.25 16.75 21.25C15.0931 21.25 13.75 19.9069 13.75 18.25C13.75 16.9438 14.5848 15.8325 15.75 15.4207V12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM16.75 17.25C16.1977 17.25 15.75 17.6977 15.75 18.25C15.75 18.8023 16.1977 19.25 16.75 19.25C17.3023 19.25 17.75 18.8023 17.75 18.25C17.75 17.6977 17.3023 17.25 16.75 17.25Z"
					fill={token('color.icon.danger')}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.5429 3.04289C13.9334 2.65237 14.5666 2.65237 14.9571 3.04289L16.75 4.83579L18.5429 3.04289C18.9334 2.65237 19.5666 2.65237 19.9571 3.04289C20.3476 3.43342 20.3476 4.06658 19.9571 4.45711L18.1642 6.25L19.9571 8.04289C20.3476 8.43342 20.3476 9.06658 19.9571 9.45711C19.5666 9.84763 18.9334 9.84763 18.5429 9.45711L16.75 7.66421L14.9571 9.45711C14.5666 9.84763 13.9334 9.84763 13.5429 9.45711C13.1524 9.06658 13.1524 8.43342 13.5429 8.04289L15.3358 6.25L13.5429 4.45711C13.1524 4.06658 13.1524 3.43342 13.5429 3.04289Z"
					fill={token('color.icon.danger')}
				/>
			</svg>
		)}
	/>
);

const PullrequestMergedIcon = ({ label }: IconProps) => (
	// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
	<Icon
		label={label}
		glyph={() => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="24" height="24" fill={token('color.icon.inverse')} fillOpacity="0.01" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5ZM3.5 6C3.5 4.34315 4.84315 3 6.5 3C8.15685 3 9.5 4.34315 9.5 6C9.5 7.30622 8.66519 8.41746 7.5 8.82929V20C7.5 20.5523 7.05228 21 6.5 21C5.94772 21 5.5 20.5523 5.5 20V8.82929C4.33481 8.41746 3.5 7.30622 3.5 6Z"
					fill={token('color.icon.success')}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.5 7C7.05228 7 7.5 7.44772 7.5 8V10C7.5 13.5912 10.2043 16.5508 13.6876 16.9534C14.1123 15.8126 15.2113 15 16.5 15C18.1569 15 19.5 16.3431 19.5 18C19.5 19.6569 18.1569 21 16.5 21C15.1793 21 14.0579 20.1466 13.6572 18.9611C9.08185 18.5362 5.5 14.6864 5.5 10V8C5.5 7.44772 5.94772 7 6.5 7ZM16.5 17C15.9477 17 15.5 17.4477 15.5 18C15.5 18.5523 15.9477 19 16.5 19C17.0523 19 17.5 18.5523 17.5 18C17.5 17.4477 17.0523 17 16.5 17Z"
					fill={token('color.icon.success')}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.2071 4.29289C20.5976 4.68342 20.5976 5.31658 20.2071 5.70711L16.2071 9.70711C15.8166 10.0976 15.1834 10.0976 14.7929 9.70711L12.7929 7.70711C12.4024 7.31658 12.4024 6.68342 12.7929 6.29289C13.1834 5.90237 13.8166 5.90237 14.2071 6.29289L15.5 7.58579L18.7929 4.29289C19.1834 3.90237 19.8166 3.90237 20.2071 4.29289Z"
					fill={token('color.icon.success')}
				/>
			</svg>
		)}
	/>
);

type Props = { pullRequestState: DevInfoType; label: string; primaryColor?: string };

export const CustomPullRequestIcon = ({
	pullRequestState,
	label,
	primaryColor,
}: Props): React.JSX.Element => {
	if (pullRequestState === DevInfoTypes.DECLINED) {
		return <PullrequestDeclinedIcon label={label} />;
	}
	if (pullRequestState === DevInfoTypes.MERGED) {
		return <PullrequestMergedIcon label={label} />;
	}

	return <PullRequestIcon label={label} LEGACY_primaryColor={primaryColor} />;
};
